module.exports = __webpack_public_path__ + "static/media/yogi4.7b0cd6de.jpg";